module.exports = __webpack_public_path__ + "2a8557400bc72b5ca31b20dfb4f761e2.mp3";